import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propArrayShape, propBool, propFunc, propOneOf, propStr, } from '../../../../../../helpers/custom-prop-types';
import SlideSearchShareStatusTabContentReceive from './SlideSearchShareStatusTabContentReceive';
import SlideSearchShareStatusTabContentShare from './SlideSearchShareStatusTabContentShare';
/**
 * タブのコンテンツ部分を表示するコンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SlideSearchShareStatusTabContent = (props) => {
    const { currentTab, isReceiveFolderOnePage, isShareHistoryOnePage, onClickItem, paramId, receiveItems, shareItems, skeletons, } = props;
    switch (currentTab) {
        case 'receive':
            return (_jsx(SlideSearchShareStatusTabContentReceive, { isReceiveFolderOnePage: isReceiveFolderOnePage, items: receiveItems, onClickItem: onClickItem, paramId: paramId, skeletons: skeletons }));
        case 'share':
            return (_jsx(SlideSearchShareStatusTabContentShare, { isShareHistoryOnePage: isShareHistoryOnePage, items: shareItems, onClickNoLink: onClickItem, paramId: paramId, skeletons: skeletons }));
        default:
            return null;
    }
};
SlideSearchShareStatusTabContent.propTypes = {
    currentTab: propOneOf(['receive', 'share']).isRequired,
    isReceiveFolderOnePage: propBool().isRequired,
    isShareHistoryOnePage: propBool().isRequired,
    onClickItem: propFunc(),
    paramId: propStr(),
    receiveItems: propArrayShape(),
    shareItems: propArrayShape(),
    skeletons: propArrayShape().isRequired,
};
SlideSearchShareStatusTabContent.defaultProps = {
    onClickItem: undefined,
    paramId: '',
    receiveItems: null,
    shareItems: null,
};
export default SlideSearchShareStatusTabContent;
